/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Yourdle.Web.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */

import * as url from "url";
import * as isomorphicFetch from "isomorphic-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "/".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
  csv: ",",
  ssv: " ",
  tsv: "\t",
  pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
  (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
  url: string;
  options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
  protected configuration: Configuration;

  constructor(
    configuration?: Configuration,
    protected basePath: string = BASE_PATH,
    protected fetch: FetchAPI = isomorphicFetch
  ) {
    if (configuration) {
      this.configuration = configuration;
      this.basePath = configuration.basePath || this.basePath;
    } else {
      this.configuration = new Configuration();
    }
  }
}

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
  name = "RequiredError";
  constructor(public field: string, msg?: string) {
    super(msg);
  }
}

/**
 *
 * @export
 * @interface CollectionCardDto
 */
export interface CollectionCardDto {
  /**
   *
   * @type {string}
   * @memberof CollectionCardDto
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof CollectionCardDto
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof CollectionCardDto
   */
  fieldCount?: number;
  /**
   *
   * @type {number}
   * @memberof CollectionCardDto
   */
  objectCount?: number;
}
/**
 *
 * @export
 * @interface CollectionDto
 */
export interface CollectionDto {
  /**
   *
   * @type {string}
   * @memberof CollectionDto
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof CollectionDto
   */
  name?: string;
  /**
   *
   * @type {Array<FieldDto>}
   * @memberof CollectionDto
   */
  fields?: Array<FieldDto>;
  /**
   *
   * @type {Array<ObjectDto>}
   * @memberof CollectionDto
   */
  objects?: Array<ObjectDto>;
}
/**
 *
 * @export
 * @interface CollectionFullDto
 */
export interface CollectionFullDto {
  /**
   *
   * @type {string}
   * @memberof CollectionFullDto
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof CollectionFullDto
   */
  name?: string;
  /**
   *
   * @type {Array<FieldDto>}
   * @memberof CollectionFullDto
   */
  fields?: Array<FieldDto>;
  /**
   *
   * @type {Array<ObjectWithFieldsDto>}
   * @memberof CollectionFullDto
   */
  objects?: Array<ObjectWithFieldsDto>;
}
/**
 *
 * @export
 * @interface CreateFieldRequest
 */
export interface CreateFieldRequest {
  /**
   *
   * @type {string}
   * @memberof CreateFieldRequest
   */
  name: string;
  /**
   *
   * @type {FieldType}
   * @memberof CreateFieldRequest
   */
  type: FieldType;
}
/**
 *
 * @export
 * @interface CreateGameRequest
 */
export interface CreateGameRequest {
  /**
   *
   * @type {string}
   * @memberof CreateGameRequest
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateGameRequest
   */
  thumbnail?: string;
  /**
   *
   * @type {string}
   * @memberof CreateGameRequest
   */
  collectionName?: string;
  /**
   *
   * @type {string}
   * @memberof CreateGameRequest
   */
  collectionId?: string;
}
/**
 *
 * @export
 * @interface CreateGameResponse
 */
export interface CreateGameResponse {
  /**
   *
   * @type {string}
   * @memberof CreateGameResponse
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof CreateGameResponse
   */
  collectionId?: string;
}
/**
 *
 * @export
 * @interface CreateObjectRequest
 */
export interface CreateObjectRequest {
  /**
   *
   * @type {string}
   * @memberof CreateObjectRequest
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CreateObjectRequest
   */
  thumbnail?: string;
  /**
   *
   * @type {Array<FieldValueDto>}
   * @memberof CreateObjectRequest
   */
  fieldValues?: Array<FieldValueDto>;
}
/**
 *
 * @export
 * @interface FieldDto
 */
export interface FieldDto {
  /**
   *
   * @type {string}
   * @memberof FieldDto
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof FieldDto
   */
  name?: string;
  /**
   *
   * @type {FieldType}
   * @memberof FieldDto
   */
  type?: FieldType;
}
/**
 *
 * @export
 * @interface FieldGuessDto
 */
export interface FieldGuessDto {
  /**
   *
   * @type {string}
   * @memberof FieldGuessDto
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof FieldGuessDto
   */
  name?: string;
  /**
   *
   * @type {FieldType}
   * @memberof FieldGuessDto
   */
  type?: FieldType;
  /**
   *
   * @type {any}
   * @memberof FieldGuessDto
   */
  value?: any;
  /**
   *
   * @type {GuessState}
   * @memberof FieldGuessDto
   */
  guessState?: GuessState;
}
/**
 *
 * @export
 * @enum {string}
 */
export enum FieldType {
  NUMBER_0 = 0,
  NUMBER_1 = 1,
  NUMBER_2 = 2,
  NUMBER_3 = 3,
}
/**
 *
 * @export
 * @interface FieldValueDto
 */
export interface FieldValueDto {
  /**
   *
   * @type {string}
   * @memberof FieldValueDto
   */
  fieldId: string;
  /**
   *
   * @type {string}
   * @memberof FieldValueDto
   */
  value: string;
}
/**
 *
 * @export
 * @interface GameCardDto
 */
export interface GameCardDto {
  /**
   *
   * @type {string}
   * @memberof GameCardDto
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof GameCardDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof GameCardDto
   */
  thumbnail?: string;
  /**
   *
   * @type {string}
   * @memberof GameCardDto
   */
  creatorName?: string;
  /**
   *
   * @type {boolean}
   * @memberof GameCardDto
   */
  public?: boolean;
  /**
   *
   * @type {Date}
   * @memberof GameCardDto
   */
  creationDate?: Date;
  /**
   *
   * @type {Array<string>}
   * @memberof GameCardDto
   */
  tags?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof GameCardDto
   */
  playersToday?: number;
  /**
   *
   * @type {number}
   * @memberof GameCardDto
   */
  playersTotal?: number;
  /**
   *
   * @type {number}
   * @memberof GameCardDto
   */
  favourited?: number;
}
/**
 *
 * @export
 * @interface GameDto
 */
export interface GameDto {
  /**
   *
   * @type {string}
   * @memberof GameDto
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof GameDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof GameDto
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof GameDto
   */
  thumbnail?: string;
  /**
   *
   * @type {UserDto}
   * @memberof GameDto
   */
  creator?: UserDto;
  /**
   *
   * @type {CollectionDto}
   * @memberof GameDto
   */
  collection?: CollectionDto;
  /**
   *
   * @type {Array<string>}
   * @memberof GameDto
   */
  tags?: Array<string>;
}
/**
 *
 * @export
 * @interface GetGameConstructorResponse
 */
export interface GetGameConstructorResponse {
  /**
   *
   * @type {GameCardDto}
   * @memberof GetGameConstructorResponse
   */
  game?: GameCardDto;
  /**
   *
   * @type {CollectionFullDto}
   * @memberof GetGameConstructorResponse
   */
  collection?: CollectionFullDto;
}
/**
 *
 * @export
 * @interface GetGameConstructorResponse
 */
export interface GetGameFullDto {
  /**
   *
   * @type {string}
   * @memberof GetGameFullDto
   */
  gameSessionId?: string;
  /**
   *
   * @type {GameDto}
   * @memberof GetGameFullDto
   */
  game?: GameDto;
}
/**
 *
 * @export
 * @interface GetGamesPaginatedResponse
 */
export interface GetGamesPaginatedResponse {
  /**
   *
   * @type {Array<GameCardDto>}
   * @memberof GetGamesPaginatedResponse
   */
  games?: Array<GameCardDto>;
  /**
   *
   * @type {PaginationInfo}
   * @memberof GetGamesPaginatedResponse
   */
  paginationInfo?: PaginationInfo;
}
/**
 *
 * @export
 * @interface GetGamesRecentResponse
 */
export interface GetGamesRecentResponse {
  /**
   *
   * @type {Array<GameCardDto>}
   * @memberof GetGamesRecentResponse
   */
  games?: Array<GameCardDto>;
}
/**
 *
 * @export
 * @interface GuessResponse
 */
export interface GuessResponse {
  /**
   *
   * @type {boolean}
   * @memberof GuessResponse
   */
  isFullGuess?: boolean;
  /**
   *
   * @type {string}
   * @memberof GuessResponse
   */
  gameSessionId?: string;
  /**
   *
   * @type {Array<FieldGuessDto>}
   * @memberof GuessResponse
   */
  fieldGuesses?: Array<FieldGuessDto>;
}
/**
 *
 * @export
 * @enum {string}
 */
export enum GuessState {
  NUMBER_0 = <any>0,
  NUMBER_1 = <any>1,
  NUMBER_2 = <any>2,
  NUMBER_3 = <any>3,
  NUMBER_4 = <any>4,
}
/**
 *
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
  /**
   *
   * @type {string}
   * @memberof LoginRequest
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof LoginRequest
   */
  password: string;
}
/**
 *
 * @export
 * @enum {string}
 */
export enum Mode {
  NUMBER_0 = <any>0,
  NUMBER_1 = <any>1,
}
/**
 *
 * @export
 * @interface ObjectDto
 */
export interface ObjectDto {
  /**
   *
   * @type {string}
   * @memberof ObjectDto
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ObjectDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ObjectDto
   */
  thumbnail?: string;
}
/**
 *
 * @export
 * @interface ObjectWithFieldsDto
 */
export interface ObjectWithFieldsDto {
  /**
   *
   * @type {string}
   * @memberof ObjectWithFieldsDto
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof ObjectWithFieldsDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ObjectWithFieldsDto
   */
  thumbnail?: string;
  /**
   *
   * @type {{ [key: string]: any; }}
   * @memberof ObjectWithFieldsDto
   */
  fieldValues?: { [key: string]: any };
}
/**
 *
 * @export
 * @enum {string}
 */
export enum OrderBy {
  NUMBER_0 = <any>0,
  NUMBER_1 = <any>1,
  NUMBER_2 = <any>2,
  NUMBER_3 = <any>3,
}
/**
 *
 * @export
 * @interface PaginationInfo
 */
export interface PaginationInfo {
  /**
   *
   * @type {number}
   * @memberof PaginationInfo
   */
  pageSize?: number;
  /**
   *
   * @type {number}
   * @memberof PaginationInfo
   */
  pageNumber?: number;
  /**
   *
   * @type {number}
   * @memberof PaginationInfo
   */
  pagesCount?: number;
}
/**
 *
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
  [key: string]: any;
}
/**
 *
 * @export
 * @interface RegisterRequest
 */
export interface RegisterRequest {
  /**
   *
   * @type {string}
   * @memberof RegisterRequest
   */
  email: string;
  /**
   *
   * @type {string}
   * @memberof RegisterRequest
   */
  username: string;
  /**
   *
   * @type {string}
   * @memberof RegisterRequest
   */
  password: string;
}
/**
 *
 * @export
 * @interface SetFieldOrderRequest
 */
export interface SetFieldOrderRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof SetFieldOrderRequest
   */
  fieldIdsInOrder: Array<string>;
}
/**
 *
 * @export
 * @interface TagCount
 */
export interface TagCount {
  /**
   *
   * @type {string}
   * @memberof TagCount
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof TagCount
   */
  count?: number;
}
/**
 *
 * @export
 * @interface UpdateFieldRequest
 */
export interface UpdateFieldRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateFieldRequest
   */
  newName?: string;
  /**
   *
   * @type {FieldType}
   * @memberof UpdateFieldRequest
   */
  newType?: FieldType;
  /**
   *
   * @type {boolean}
   * @memberof UpdateFieldRequest
   */
  keepExistingDataIfPossible?: boolean;
}
/**
 *
 * @export
 * @interface UpdateGameRequest
 */
export interface UpdateGameRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateGameRequest
   */
  newName?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateGameRequest
   */
  newThumbnail?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateGameRequest
   */
  newDescription?: string;
}
/**
 *
 * @export
 * @interface UpdateObjectRequest
 */
export interface UpdateObjectRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateObjectRequest
   */
  newName?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateObjectRequest
   */
  newThumbnail?: string;
  /**
   *
   * @type {Array<FieldValueDto>}
   * @memberof UpdateObjectRequest
   */
  newFieldValues?: Array<FieldValueDto>;
}
/**
 *
 * @export
 * @interface UpdateTagRequest
 */
export interface UpdateTagRequest {
  /**
   *
   * @type {Mode}
   * @memberof UpdateTagRequest
   */
  mode?: Mode;
  /**
   *
   * @type {string}
   * @memberof UpdateTagRequest
   */
  name?: string;
}
/**
 *
 * @export
 * @interface UpdateTagResponse
 */
export interface UpdateTagResponse {
  /**
   *
   * @type {string}
   * @memberof UpdateTagResponse
   */
  name?: string;
  /**
   *
   * @type {any}
   * @memberof UpdateTagResponse
   */
  result?: any;
}
/**
 *
 * @export
 * @interface UserDto
 */
export interface UserDto {
  /**
   *
   * @type {string}
   * @memberof UserDto
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof UserDto
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof UserDto
   */
  email?: string;
}
/**
 *
 * @export
 * @interface UserInfoResponse
 */
export interface UserInfoResponse {
  /**
   *
   * @type {UserDto}
   * @memberof UserInfoResponse
   */
  user?: UserDto;
}
/**
 * CollectionsApi - fetch parameter creator
 * @export
 */
export const CollectionsApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} collectionId
     * @param {string} fieldId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdFieldsFieldIdDelete(
      collectionId: string,
      fieldId: string,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'collectionId' is not null or undefined
      if (collectionId === null || collectionId === undefined) {
        throw new RequiredError(
          "collectionId",
          "Required parameter collectionId was null or undefined when calling collectionsCollectionIdFieldsFieldIdDelete."
        );
      }
      // verify required parameter 'fieldId' is not null or undefined
      if (fieldId === null || fieldId === undefined) {
        throw new RequiredError(
          "fieldId",
          "Required parameter fieldId was null or undefined when calling collectionsCollectionIdFieldsFieldIdDelete."
        );
      }
      const localVarPath = `/Collections/{collectionId}/fields/{fieldId}`
        .replace(
          `{${"collectionId"}}`,
          encodeURIComponent(String(collectionId))
        )
        .replace(`{${"fieldId"}}`, encodeURIComponent(String(fieldId)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} collectionId
     * @param {string} fieldId
     * @param {UpdateFieldRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdFieldsFieldIdPut(
      collectionId: string,
      fieldId: string,
      body?: UpdateFieldRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'collectionId' is not null or undefined
      if (collectionId === null || collectionId === undefined) {
        throw new RequiredError(
          "collectionId",
          "Required parameter collectionId was null or undefined when calling collectionsCollectionIdFieldsFieldIdPut."
        );
      }
      // verify required parameter 'fieldId' is not null or undefined
      if (fieldId === null || fieldId === undefined) {
        throw new RequiredError(
          "fieldId",
          "Required parameter fieldId was null or undefined when calling collectionsCollectionIdFieldsFieldIdPut."
        );
      }
      const localVarPath = `/Collections/{collectionId}/fields/{fieldId}`
        .replace(
          `{${"collectionId"}}`,
          encodeURIComponent(String(collectionId))
        )
        .replace(`{${"fieldId"}}`, encodeURIComponent(String(fieldId)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"UpdateFieldRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} collectionId
     * @param {CreateFieldRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdFieldsPost(
      collectionId: string,
      body?: CreateFieldRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'collectionId' is not null or undefined
      if (collectionId === null || collectionId === undefined) {
        throw new RequiredError(
          "collectionId",
          "Required parameter collectionId was null or undefined when calling collectionsCollectionIdFieldsPost."
        );
      }
      const localVarPath = `/Collections/{collectionId}/fields`.replace(
        `{${"collectionId"}}`,
        encodeURIComponent(String(collectionId))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"CreateFieldRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} collectionId
     * @param {SetFieldOrderRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdFieldsSetOrderPatch(
      collectionId: string,
      body?: SetFieldOrderRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'collectionId' is not null or undefined
      if (collectionId === null || collectionId === undefined) {
        throw new RequiredError(
          "collectionId",
          "Required parameter collectionId was null or undefined when calling collectionsCollectionIdFieldsSetOrderPatch."
        );
      }
      const localVarPath =
        `/Collections/{collectionId}/fields/setOrder`.replace(
          `{${"collectionId"}}`,
          encodeURIComponent(String(collectionId))
        );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "PATCH" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"SetFieldOrderRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} collectionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdGet(
      collectionId: string,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'collectionId' is not null or undefined
      if (collectionId === null || collectionId === undefined) {
        throw new RequiredError(
          "collectionId",
          "Required parameter collectionId was null or undefined when calling collectionsCollectionIdGet."
        );
      }
      const localVarPath = `/Collections/{collectionId}`.replace(
        `{${"collectionId"}}`,
        encodeURIComponent(String(collectionId))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} collectionId
     * @param {string} objectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdObjectsObjectIdDelete(
      collectionId: string,
      objectId: string,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'collectionId' is not null or undefined
      if (collectionId === null || collectionId === undefined) {
        throw new RequiredError(
          "collectionId",
          "Required parameter collectionId was null or undefined when calling collectionsCollectionIdObjectsObjectIdDelete."
        );
      }
      // verify required parameter 'objectId' is not null or undefined
      if (objectId === null || objectId === undefined) {
        throw new RequiredError(
          "objectId",
          "Required parameter objectId was null or undefined when calling collectionsCollectionIdObjectsObjectIdDelete."
        );
      }
      const localVarPath = `/Collections/{collectionId}/objects/{objectId}`
        .replace(
          `{${"collectionId"}}`,
          encodeURIComponent(String(collectionId))
        )
        .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "DELETE" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} collectionId
     * @param {string} objectId
     * @param {UpdateObjectRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdObjectsObjectIdPut(
      collectionId: string,
      objectId: string,
      body?: UpdateObjectRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'collectionId' is not null or undefined
      if (collectionId === null || collectionId === undefined) {
        throw new RequiredError(
          "collectionId",
          "Required parameter collectionId was null or undefined when calling collectionsCollectionIdObjectsObjectIdPut."
        );
      }
      // verify required parameter 'objectId' is not null or undefined
      if (objectId === null || objectId === undefined) {
        throw new RequiredError(
          "objectId",
          "Required parameter objectId was null or undefined when calling collectionsCollectionIdObjectsObjectIdPut."
        );
      }
      const localVarPath = `/Collections/{collectionId}/objects/{objectId}`
        .replace(
          `{${"collectionId"}}`,
          encodeURIComponent(String(collectionId))
        )
        .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"UpdateObjectRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} collectionId
     * @param {CreateObjectRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdObjectsPost(
      collectionId: string,
      body?: CreateObjectRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'collectionId' is not null or undefined
      if (collectionId === null || collectionId === undefined) {
        throw new RequiredError(
          "collectionId",
          "Required parameter collectionId was null or undefined when calling collectionsCollectionIdObjectsPost."
        );
      }
      const localVarPath = `/Collections/{collectionId}/objects`.replace(
        `{${"collectionId"}}`,
        encodeURIComponent(String(collectionId))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"CreateObjectRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsGet(options: any = {}): FetchArgs {
      const localVarPath = `/Collections`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * CollectionsApi - functional programming interface
 * @export
 */
export const CollectionsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} collectionId
     * @param {string} fieldId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdFieldsFieldIdDelete(
      collectionId: string,
      fieldId: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CollectionsApiFetchParamCreator(
        configuration
      ).collectionsCollectionIdFieldsFieldIdDelete(
        collectionId,
        fieldId,
        options
      );
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {string} collectionId
     * @param {string} fieldId
     * @param {UpdateFieldRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdFieldsFieldIdPut(
      collectionId: string,
      fieldId: string,
      body?: UpdateFieldRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CollectionsApiFetchParamCreator(
        configuration
      ).collectionsCollectionIdFieldsFieldIdPut(
        collectionId,
        fieldId,
        body,
        options
      );
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {string} collectionId
     * @param {CreateFieldRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdFieldsPost(
      collectionId: string,
      body?: CreateFieldRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<FieldDto> {
      const localVarFetchArgs = CollectionsApiFetchParamCreator(
        configuration
      ).collectionsCollectionIdFieldsPost(collectionId, body, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {string} collectionId
     * @param {SetFieldOrderRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdFieldsSetOrderPatch(
      collectionId: string,
      body?: SetFieldOrderRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CollectionsApiFetchParamCreator(
        configuration
      ).collectionsCollectionIdFieldsSetOrderPatch(collectionId, body, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {string} collectionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdGet(
      collectionId: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<CollectionDto> {
      const localVarFetchArgs = CollectionsApiFetchParamCreator(
        configuration
      ).collectionsCollectionIdGet(collectionId, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {string} collectionId
     * @param {string} objectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdObjectsObjectIdDelete(
      collectionId: string,
      objectId: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CollectionsApiFetchParamCreator(
        configuration
      ).collectionsCollectionIdObjectsObjectIdDelete(
        collectionId,
        objectId,
        options
      );
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {string} collectionId
     * @param {string} objectId
     * @param {UpdateObjectRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdObjectsObjectIdPut(
      collectionId: string,
      objectId: string,
      body?: UpdateObjectRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = CollectionsApiFetchParamCreator(
        configuration
      ).collectionsCollectionIdObjectsObjectIdPut(
        collectionId,
        objectId,
        body,
        options
      );
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {string} collectionId
     * @param {CreateObjectRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdObjectsPost(
      collectionId: string,
      body?: CreateObjectRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<ObjectWithFieldsDto> {
      const localVarFetchArgs = CollectionsApiFetchParamCreator(
        configuration
      ).collectionsCollectionIdObjectsPost(collectionId, body, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsGet(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<CollectionCardDto> {
      const localVarFetchArgs =
        CollectionsApiFetchParamCreator(configuration).collectionsGet(options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * CollectionsApi - factory interface
 * @export
 */
export const CollectionsApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @param {string} collectionId
     * @param {string} fieldId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdFieldsFieldIdDelete(
      collectionId: string,
      fieldId: string,
      options?: any
    ) {
      return CollectionsApiFp(
        configuration
      ).collectionsCollectionIdFieldsFieldIdDelete(
        collectionId,
        fieldId,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @param {string} collectionId
     * @param {string} fieldId
     * @param {UpdateFieldRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdFieldsFieldIdPut(
      collectionId: string,
      fieldId: string,
      body?: UpdateFieldRequest,
      options?: any
    ) {
      return CollectionsApiFp(
        configuration
      ).collectionsCollectionIdFieldsFieldIdPut(
        collectionId,
        fieldId,
        body,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @param {string} collectionId
     * @param {CreateFieldRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdFieldsPost(
      collectionId: string,
      body?: CreateFieldRequest,
      options?: any
    ) {
      return CollectionsApiFp(configuration).collectionsCollectionIdFieldsPost(
        collectionId,
        body,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @param {string} collectionId
     * @param {SetFieldOrderRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdFieldsSetOrderPatch(
      collectionId: string,
      body?: SetFieldOrderRequest,
      options?: any
    ) {
      return CollectionsApiFp(
        configuration
      ).collectionsCollectionIdFieldsSetOrderPatch(
        collectionId,
        body,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @param {string} collectionId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdGet(collectionId: string, options?: any) {
      return CollectionsApiFp(configuration).collectionsCollectionIdGet(
        collectionId,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @param {string} collectionId
     * @param {string} objectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdObjectsObjectIdDelete(
      collectionId: string,
      objectId: string,
      options?: any
    ) {
      return CollectionsApiFp(
        configuration
      ).collectionsCollectionIdObjectsObjectIdDelete(
        collectionId,
        objectId,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @param {string} collectionId
     * @param {string} objectId
     * @param {UpdateObjectRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdObjectsObjectIdPut(
      collectionId: string,
      objectId: string,
      body?: UpdateObjectRequest,
      options?: any
    ) {
      return CollectionsApiFp(
        configuration
      ).collectionsCollectionIdObjectsObjectIdPut(
        collectionId,
        objectId,
        body,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @param {string} collectionId
     * @param {CreateObjectRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsCollectionIdObjectsPost(
      collectionId: string,
      body?: CreateObjectRequest,
      options?: any
    ) {
      return CollectionsApiFp(configuration).collectionsCollectionIdObjectsPost(
        collectionId,
        body,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    collectionsGet(options?: any) {
      return CollectionsApiFp(configuration).collectionsGet(options)(
        fetch,
        basePath
      );
    },
  };
};

/**
 * CollectionsApi - object-oriented interface
 * @export
 * @class CollectionsApi
 * @extends {BaseAPI}
 */
export class CollectionsApi extends BaseAPI {
  /**
   *
   * @param {string} collectionId
   * @param {string} fieldId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CollectionsApi
   */
  public collectionsCollectionIdFieldsFieldIdDelete(
    collectionId: string,
    fieldId: string,
    options?: any
  ) {
    options = {};
    options["credentials"] = "include";
    return CollectionsApiFp(
      this.configuration
    ).collectionsCollectionIdFieldsFieldIdDelete(
      collectionId,
      fieldId,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @param {string} collectionId
   * @param {string} fieldId
   * @param {UpdateFieldRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CollectionsApi
   */
  public collectionsCollectionIdFieldsFieldIdPut(
    collectionId: string,
    fieldId: string,
    body?: UpdateFieldRequest,
    options?: any
  ) {
    options = {};
    options["credentials"] = "include";
    return CollectionsApiFp(
      this.configuration
    ).collectionsCollectionIdFieldsFieldIdPut(
      collectionId,
      fieldId,
      body,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @param {string} collectionId
   * @param {CreateFieldRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CollectionsApi
   */
  public collectionsCollectionIdFieldsPost(
    collectionId: string,
    body?: CreateFieldRequest,
    options?: any
  ) {
    options = {};
    options["credentials"] = "include";
    return CollectionsApiFp(
      this.configuration
    ).collectionsCollectionIdFieldsPost(
      collectionId,
      body,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @param {string} collectionId
   * @param {SetFieldOrderRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CollectionsApi
   */
  public collectionsCollectionIdFieldsSetOrderPatch(
    collectionId: string,
    body?: SetFieldOrderRequest,
    options?: any
  ) {
    options = {};
    options["credentials"] = "include";
    return CollectionsApiFp(
      this.configuration
    ).collectionsCollectionIdFieldsSetOrderPatch(
      collectionId,
      body,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @param {string} collectionId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CollectionsApi
   */
  public collectionsCollectionIdGet(collectionId: string, options?: any) {
    options = {};
    options["credentials"] = "include";
    return CollectionsApiFp(this.configuration).collectionsCollectionIdGet(
      collectionId,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @param {string} collectionId
   * @param {string} objectId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CollectionsApi
   */
  public collectionsCollectionIdObjectsObjectIdDelete(
    collectionId: string,
    objectId: string,
    options?: any
  ) {
    options = {};
    options["credentials"] = "include";
    return CollectionsApiFp(
      this.configuration
    ).collectionsCollectionIdObjectsObjectIdDelete(
      collectionId,
      objectId,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @param {string} collectionId
   * @param {string} objectId
   * @param {UpdateObjectRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CollectionsApi
   */
  public collectionsCollectionIdObjectsObjectIdPut(
    collectionId: string,
    objectId: string,
    body?: UpdateObjectRequest,
    options?: any
  ) {
    options = {};
    options["credentials"] = "include";
    return CollectionsApiFp(
      this.configuration
    ).collectionsCollectionIdObjectsObjectIdPut(
      collectionId,
      objectId,
      body,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @param {string} collectionId
   * @param {CreateObjectRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CollectionsApi
   */
  public collectionsCollectionIdObjectsPost(
    collectionId: string,
    body?: CreateObjectRequest,
    options?: any
  ) {
    options = {};
    options["credentials"] = "include";
    return CollectionsApiFp(
      this.configuration
    ).collectionsCollectionIdObjectsPost(
      collectionId,
      body,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof CollectionsApi
   */
  public collectionsGet(options?: any) {
    options = {};
    options["credentials"] = "include";
    return CollectionsApiFp(this.configuration).collectionsGet(options)(
      this.fetch,
      this.basePath
    );
  }
}
/**
 * GamesApi - fetch parameter creator
 * @export
 */
export const GamesApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} gameId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdCardGet(gameId: string, options: any = {}): FetchArgs {
      // verify required parameter 'gameId' is not null or undefined
      if (gameId === null || gameId === undefined) {
        throw new RequiredError(
          "gameId",
          "Required parameter gameId was null or undefined when calling gamesGameIdCardGet."
        );
      }
      const localVarPath = `/Games/{gameId}/card`.replace(
        `{${"gameId"}}`,
        encodeURIComponent(String(gameId))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} gameId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdConstructorGet(gameId: string, options: any = {}): FetchArgs {
      // verify required parameter 'gameId' is not null or undefined
      if (gameId === null || gameId === undefined) {
        throw new RequiredError(
          "gameId",
          "Required parameter gameId was null or undefined when calling gamesGameIdConstructorGet."
        );
      }
      const localVarPath = `/Games/{gameId}/constructor`.replace(
        `{${"gameId"}}`,
        encodeURIComponent(String(gameId))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} gameId
     * @param {Array<string>} [tags]
     * @param {Array<string>} [keywords]
     * @param {boolean} [own]
     * @param {boolean} [favourite]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdFullGet(
      gameId: string,
      tags?: Array<string>,
      keywords?: Array<string>,
      own?: boolean,
      favourite?: boolean,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'gameId' is not null or undefined
      if (gameId === null || gameId === undefined) {
        throw new RequiredError(
          "gameId",
          "Required parameter gameId was null or undefined when calling gamesGameIdFullGet."
        );
      }
      const localVarPath = `/Games/{gameId}/full`.replace(
        `{${"gameId"}}`,
        encodeURIComponent(String(gameId))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (tags) {
        localVarQueryParameter["Tags"] = tags;
      }

      if (keywords) {
        localVarQueryParameter["Keywords"] = keywords;
      }

      if (own !== undefined) {
        localVarQueryParameter["Own"] = own;
      }

      if (favourite !== undefined) {
        localVarQueryParameter["Favourite"] = favourite;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} gameId
     * @param {string} objectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdGuessObjectIdPost(
      gameId: string,
      objectId: string,
      gameSessionId: string,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'gameId' is not null or undefined
      if (gameId === null || gameId === undefined) {
        throw new RequiredError(
          "gameId",
          "Required parameter gameId was null or undefined when calling gamesGameIdGuessObjectIdPost."
        );
      }
      // verify required parameter 'objectId' is not null or undefined
      if (objectId === null || objectId === undefined) {
        throw new RequiredError(
          "objectId",
          "Required parameter objectId was null or undefined when calling gamesGameIdGuessObjectIdPost."
        );
      }
      const localVarPath = `/Games/{gameId}/guess/{objectId}`
        .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)))
        .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = { "gameSessionId": encodeURIComponent(String(gameSessionId)) } as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} gameId
     * @param {UpdateGameRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdPut(
      gameId: string,
      body?: UpdateGameRequest,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'gameId' is not null or undefined
      if (gameId === null || gameId === undefined) {
        throw new RequiredError(
          "gameId",
          "Required parameter gameId was null or undefined when calling gamesGameIdPut."
        );
      }
      const localVarPath = `/Games/{gameId}`.replace(
        `{${"gameId"}}`,
        encodeURIComponent(String(gameId))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"UpdateGameRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} gameId
     * @param {boolean} setFavourite
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdSetFavouriteSetFavouritePatch(
      gameId: string,
      setFavourite: boolean,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'gameId' is not null or undefined
      if (gameId === null || gameId === undefined) {
        throw new RequiredError(
          "gameId",
          "Required parameter gameId was null or undefined when calling gamesGameIdSetFavouriteSetFavouritePatch."
        );
      }
      // verify required parameter 'setFavourite' is not null or undefined
      if (setFavourite === null || setFavourite === undefined) {
        throw new RequiredError(
          "setFavourite",
          "Required parameter setFavourite was null or undefined when calling gamesGameIdSetFavouriteSetFavouritePatch."
        );
      }
      const localVarPath = `/Games/{gameId}/setFavourite/{setFavourite}`
        .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)))
        .replace(
          `{${"setFavourite"}}`,
          encodeURIComponent(String(setFavourite))
        );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "PATCH" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} gameId
     * @param {boolean} isPublic
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdSetPublicIsPublicPut(
      gameId: string,
      isPublic: boolean,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'gameId' is not null or undefined
      if (gameId === null || gameId === undefined) {
        throw new RequiredError(
          "gameId",
          "Required parameter gameId was null or undefined when calling gamesGameIdSetPublicIsPublicPut."
        );
      }
      // verify required parameter 'isPublic' is not null or undefined
      if (isPublic === null || isPublic === undefined) {
        throw new RequiredError(
          "isPublic",
          "Required parameter isPublic was null or undefined when calling gamesGameIdSetPublicIsPublicPut."
        );
      }
      const localVarPath = `/Games/{gameId}/setPublic/{isPublic}`
        .replace(`{${"gameId"}}`, encodeURIComponent(String(gameId)))
        .replace(`{${"isPublic"}}`, encodeURIComponent(String(isPublic)));
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} gameId
     * @param {Array<UpdateTagRequest>} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdTagsPatch(
      gameId: string,
      body?: Array<UpdateTagRequest>,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'gameId' is not null or undefined
      if (gameId === null || gameId === undefined) {
        throw new RequiredError(
          "gameId",
          "Required parameter gameId was null or undefined when calling gamesGameIdTagsPatch."
        );
      }
      const localVarPath = `/Games/{gameId}/tags`.replace(
        `{${"gameId"}}`,
        encodeURIComponent(String(gameId))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign(
        { method: "PATCH" },
        options
      );
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"Array&lt;UpdateTagRequest&gt;" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} gameId
     * @param {Array<string>} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdTagsPut(
      gameId: string,
      body?: Array<string>,
      options: any = {}
    ): FetchArgs {
      // verify required parameter 'gameId' is not null or undefined
      if (gameId === null || gameId === undefined) {
        throw new RequiredError(
          "gameId",
          "Required parameter gameId was null or undefined when calling gamesGameIdTagsPut."
        );
      }
      const localVarPath = `/Games/{gameId}/tags`.replace(
        `{${"gameId"}}`,
        encodeURIComponent(String(gameId))
      );
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "PUT" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"Array&lt;string&gt;" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [paginationInfoPageSize]
     * @param {number} [paginationInfoPageNumber]
     * @param {number} [paginationInfoPagesCount]
     * @param {Array<string>} [filterTags]
     * @param {Array<string>} [filterKeywords]
     * @param {boolean} [filterOwn]
     * @param {boolean} [filterFavourite]
     * @param {OrderBy} [ordering]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGet(
      paginationInfoPageSize?: number,
      paginationInfoPageNumber?: number,
      paginationInfoPagesCount?: number,
      filterTags?: Array<string>,
      filterKeywords?: Array<string>,
      filterOwn?: boolean,
      filterFavourite?: boolean,
      ordering?: OrderBy,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/Games`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (paginationInfoPageSize !== undefined) {
        localVarQueryParameter["PaginationInfo.PageSize"] =
          paginationInfoPageSize;
      }

      if (paginationInfoPageNumber !== undefined) {
        localVarQueryParameter["PaginationInfo.PageNumber"] =
          paginationInfoPageNumber;
      }

      if (paginationInfoPagesCount !== undefined) {
        localVarQueryParameter["PaginationInfo.PagesCount"] =
          paginationInfoPagesCount;
      }

      if (filterTags) {
        localVarQueryParameter["Filter.Tags"] = filterTags;
      }

      if (filterKeywords) {
        localVarQueryParameter["Filter.Keywords"] = filterKeywords;
      }

      if (filterOwn !== undefined) {
        localVarQueryParameter["Filter.Own"] = filterOwn;
      }

      if (filterFavourite !== undefined) {
        localVarQueryParameter["Filter.Favourite"] = filterFavourite;
      }

      if (ordering !== undefined) {
        localVarQueryParameter["Ordering"] = ordering;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {number} [paginationInfoPageSize]
     * @param {number} [paginationInfoPageNumber]
     * @param {number} [paginationInfoPagesCount]
     * @param {Array<string>} [filterTags]
     * @param {Array<string>} [filterKeywords]
     * @param {boolean} [filterOwn]
     * @param {boolean} [filterFavourite]
     * @param {OrderBy} [ordering]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesOwnGet(
      paginationInfoPageSize?: number,
      paginationInfoPageNumber?: number,
      paginationInfoPagesCount?: number,
      filterTags?: Array<string>,
      filterKeywords?: Array<string>,
      filterOwn?: boolean,
      filterFavourite?: boolean,
      ordering?: OrderBy,
      options: any = {}
    ): FetchArgs {
      const localVarPath = `/Games/own`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (paginationInfoPageSize !== undefined) {
        localVarQueryParameter["PaginationInfo.PageSize"] =
          paginationInfoPageSize;
      }

      if (paginationInfoPageNumber !== undefined) {
        localVarQueryParameter["PaginationInfo.PageNumber"] =
          paginationInfoPageNumber;
      }

      if (paginationInfoPagesCount !== undefined) {
        localVarQueryParameter["PaginationInfo.PagesCount"] =
          paginationInfoPagesCount;
      }

      if (filterTags) {
        localVarQueryParameter["Filter.Tags"] = filterTags;
      }

      if (filterKeywords) {
        localVarQueryParameter["Filter.Keywords"] = filterKeywords;
      }

      if (filterOwn !== undefined) {
        localVarQueryParameter["Filter.Own"] = filterOwn;
      }

      if (filterFavourite !== undefined) {
        localVarQueryParameter["Filter.Favourite"] = filterFavourite;
      }

      if (ordering !== undefined) {
        localVarQueryParameter["Ordering"] = ordering;
      }

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {CreateGameRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesPost(body?: CreateGameRequest, options: any = {}): FetchArgs {
      const localVarPath = `/Games`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"CreateGameRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesRecentGet(options: any = {}): FetchArgs {
      const localVarPath = `/Games/recent`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * GamesApi - functional programming interface
 * @export
 */
export const GamesApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} gameId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdCardGet(
      gameId: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<GameCardDto> {
      const localVarFetchArgs = GamesApiFetchParamCreator(
        configuration
      ).gamesGameIdCardGet(gameId, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {string} gameId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdConstructorGet(
      gameId: string,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetGameConstructorResponse> {
      const localVarFetchArgs = GamesApiFetchParamCreator(
        configuration
      ).gamesGameIdConstructorGet(gameId, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {string} gameId
     * @param {Array<string>} [tags]
     * @param {Array<string>} [keywords]
     * @param {boolean} [own]
     * @param {boolean} [favourite]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdFullGet(
      gameId: string,
      tags?: Array<string>,
      keywords?: Array<string>,
      own?: boolean,
      favourite?: boolean,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<GetGameFullDto> {
      const localVarFetchArgs = GamesApiFetchParamCreator(
        configuration
      ).gamesGameIdFullGet(gameId, tags, keywords, own, favourite, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {string} gameId
     * @param {string} objectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdGuessObjectIdPost(
      gameId: string,
      objectId: string,
      gameSessionId: string,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<GuessResponse> {
      const localVarFetchArgs = GamesApiFetchParamCreator(
        configuration
      ).gamesGameIdGuessObjectIdPost(gameId, objectId, gameSessionId, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {string} gameId
     * @param {UpdateGameRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdPut(
      gameId: string,
      body?: UpdateGameRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<GameCardDto> {
      const localVarFetchArgs = GamesApiFetchParamCreator(
        configuration
      ).gamesGameIdPut(gameId, body, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {string} gameId
     * @param {boolean} setFavourite
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdSetFavouriteSetFavouritePatch(
      gameId: string,
      setFavourite: boolean,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = GamesApiFetchParamCreator(
        configuration
      ).gamesGameIdSetFavouriteSetFavouritePatch(gameId, setFavourite, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {string} gameId
     * @param {boolean} isPublic
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdSetPublicIsPublicPut(
      gameId: string,
      isPublic: boolean,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = GamesApiFetchParamCreator(
        configuration
      ).gamesGameIdSetPublicIsPublicPut(gameId, isPublic, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {string} gameId
     * @param {Array<UpdateTagRequest>} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdTagsPatch(
      gameId: string,
      body?: Array<UpdateTagRequest>,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<Array<UpdateTagResponse>> {
      const localVarFetchArgs = GamesApiFetchParamCreator(
        configuration
      ).gamesGameIdTagsPatch(gameId, body, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {string} gameId
     * @param {Array<string>} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdTagsPut(
      gameId: string,
      body?: Array<string>,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<string>> {
      const localVarFetchArgs = GamesApiFetchParamCreator(
        configuration
      ).gamesGameIdTagsPut(gameId, body, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {number} [paginationInfoPageSize]
     * @param {number} [paginationInfoPageNumber]
     * @param {number} [paginationInfoPagesCount]
     * @param {Array<string>} [filterTags]
     * @param {Array<string>} [filterKeywords]
     * @param {boolean} [filterOwn]
     * @param {boolean} [filterFavourite]
     * @param {OrderBy} [ordering]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGet(
      paginationInfoPageSize?: number,
      paginationInfoPageNumber?: number,
      paginationInfoPagesCount?: number,
      filterTags?: Array<string>,
      filterKeywords?: Array<string>,
      filterOwn?: boolean,
      filterFavourite?: boolean,
      ordering?: OrderBy,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetGamesPaginatedResponse> {
      const localVarFetchArgs = GamesApiFetchParamCreator(
        configuration
      ).gamesGet(
        paginationInfoPageSize,
        paginationInfoPageNumber,
        paginationInfoPagesCount,
        filterTags,
        filterKeywords,
        filterOwn,
        filterFavourite,
        ordering,
        options
      );
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {number} [paginationInfoPageSize]
     * @param {number} [paginationInfoPageNumber]
     * @param {number} [paginationInfoPagesCount]
     * @param {Array<string>} [filterTags]
     * @param {Array<string>} [filterKeywords]
     * @param {boolean} [filterOwn]
     * @param {boolean} [filterFavourite]
     * @param {OrderBy} [ordering]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesOwnGet(
      paginationInfoPageSize?: number,
      paginationInfoPageNumber?: number,
      paginationInfoPagesCount?: number,
      filterTags?: Array<string>,
      filterKeywords?: Array<string>,
      filterOwn?: boolean,
      filterFavourite?: boolean,
      ordering?: OrderBy,
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetGamesPaginatedResponse> {
      const localVarFetchArgs = GamesApiFetchParamCreator(
        configuration
      ).gamesOwnGet(
        paginationInfoPageSize,
        paginationInfoPageNumber,
        paginationInfoPagesCount,
        filterTags,
        filterKeywords,
        filterOwn,
        filterFavourite,
        ordering,
        options
      );
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {CreateGameRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesPost(
      body?: CreateGameRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<CreateGameResponse> {
      const localVarFetchArgs = GamesApiFetchParamCreator(
        configuration
      ).gamesPost(body, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesRecentGet(
      options?: any
    ): (
      fetch?: FetchAPI,
      basePath?: string
    ) => Promise<GetGamesRecentResponse> {
      const localVarFetchArgs =
        GamesApiFetchParamCreator(configuration).gamesRecentGet(options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * GamesApi - factory interface
 * @export
 */
export const GamesApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @param {string} gameId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdCardGet(gameId: string, options?: any) {
      return GamesApiFp(configuration).gamesGameIdCardGet(gameId, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @param {string} gameId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdConstructorGet(gameId: string, options?: any) {
      return GamesApiFp(configuration).gamesGameIdConstructorGet(
        gameId,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @param {string} gameId
     * @param {Array<string>} [tags]
     * @param {Array<string>} [keywords]
     * @param {boolean} [own]
     * @param {boolean} [favourite]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdFullGet(
      gameId: string,
      tags?: Array<string>,
      keywords?: Array<string>,
      own?: boolean,
      favourite?: boolean,
      options?: any
    ) {
      return GamesApiFp(configuration).gamesGameIdFullGet(
        gameId,
        tags,
        keywords,
        own,
        favourite,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @param {string} gameId
     * @param {string} objectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdGuessObjectIdPost(
      gameId: string,
      objectId: string,
      options?: any
    ) {
      return GamesApiFp(configuration).gamesGameIdGuessObjectIdPost(
        gameId,
        objectId,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @param {string} gameId
     * @param {UpdateGameRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdPut(gameId: string, body?: UpdateGameRequest, options?: any) {
      return GamesApiFp(configuration).gamesGameIdPut(
        gameId,
        body,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @param {string} gameId
     * @param {boolean} setFavourite
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdSetFavouriteSetFavouritePatch(
      gameId: string,
      setFavourite: boolean,
      options?: any
    ) {
      return GamesApiFp(configuration).gamesGameIdSetFavouriteSetFavouritePatch(
        gameId,
        setFavourite,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @param {string} gameId
     * @param {boolean} isPublic
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdSetPublicIsPublicPut(
      gameId: string,
      isPublic: boolean,
      options?: any
    ) {
      return GamesApiFp(configuration).gamesGameIdSetPublicIsPublicPut(
        gameId,
        isPublic,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @param {string} gameId
     * @param {Array<UpdateTagRequest>} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdTagsPatch(
      gameId: string,
      body?: Array<UpdateTagRequest>,
      options?: any
    ) {
      return GamesApiFp(configuration).gamesGameIdTagsPatch(
        gameId,
        body,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @param {string} gameId
     * @param {Array<string>} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGameIdTagsPut(gameId: string, body?: Array<string>, options?: any) {
      return GamesApiFp(configuration).gamesGameIdTagsPut(
        gameId,
        body,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @param {number} [paginationInfoPageSize]
     * @param {number} [paginationInfoPageNumber]
     * @param {number} [paginationInfoPagesCount]
     * @param {Array<string>} [filterTags]
     * @param {Array<string>} [filterKeywords]
     * @param {boolean} [filterOwn]
     * @param {boolean} [filterFavourite]
     * @param {OrderBy} [ordering]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesGet(
      paginationInfoPageSize?: number,
      paginationInfoPageNumber?: number,
      paginationInfoPagesCount?: number,
      filterTags?: Array<string>,
      filterKeywords?: Array<string>,
      filterOwn?: boolean,
      filterFavourite?: boolean,
      ordering?: OrderBy,
      options?: any
    ) {
      return GamesApiFp(configuration).gamesGet(
        paginationInfoPageSize,
        paginationInfoPageNumber,
        paginationInfoPagesCount,
        filterTags,
        filterKeywords,
        filterOwn,
        filterFavourite,
        ordering,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @param {number} [paginationInfoPageSize]
     * @param {number} [paginationInfoPageNumber]
     * @param {number} [paginationInfoPagesCount]
     * @param {Array<string>} [filterTags]
     * @param {Array<string>} [filterKeywords]
     * @param {boolean} [filterOwn]
     * @param {boolean} [filterFavourite]
     * @param {OrderBy} [ordering]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesOwnGet(
      paginationInfoPageSize?: number,
      paginationInfoPageNumber?: number,
      paginationInfoPagesCount?: number,
      filterTags?: Array<string>,
      filterKeywords?: Array<string>,
      filterOwn?: boolean,
      filterFavourite?: boolean,
      ordering?: OrderBy,
      options?: any
    ) {
      return GamesApiFp(configuration).gamesOwnGet(
        paginationInfoPageSize,
        paginationInfoPageNumber,
        paginationInfoPagesCount,
        filterTags,
        filterKeywords,
        filterOwn,
        filterFavourite,
        ordering,
        options
      )(fetch, basePath);
    },
    /**
     *
     * @param {CreateGameRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesPost(body?: CreateGameRequest, options?: any) {
      return GamesApiFp(configuration).gamesPost(body, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    gamesRecentGet(options?: any) {
      return GamesApiFp(configuration).gamesRecentGet(options)(fetch, basePath);
    },
  };
};

/**
 * GamesApi - object-oriented interface
 * @export
 * @class GamesApi
 * @extends {BaseAPI}
 */
export class GamesApi extends BaseAPI {
  /**
   *
   * @param {string} gameId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GamesApi
   */
  public gamesGameIdCardGet(gameId: string, options?: any) {
    options = {};
    options["credentials"] = "include";
    return GamesApiFp(this.configuration).gamesGameIdCardGet(gameId, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @param {string} gameId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GamesApi
   */
  public gamesGameIdConstructorGet(gameId: string, options?: any) {
    options = {};
    options["credentials"] = "include";
    return GamesApiFp(this.configuration).gamesGameIdConstructorGet(
      gameId,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @param {string} gameId
   * @param {Array<string>} [tags]
   * @param {Array<string>} [keywords]
   * @param {boolean} [own]
   * @param {boolean} [favourite]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GamesApi
   */
  public gamesGameIdFullGet(
    gameId: string,
    tags?: Array<string>,
    keywords?: Array<string>,
    own?: boolean,
    favourite?: boolean,
    options?: any
  ) {
    options = {} as any
    options["credentials"] = "include";
    return GamesApiFp(this.configuration).gamesGameIdFullGet(
      gameId,
      tags,
      keywords,
      own,
      favourite,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @param {string} gameId
   * @param {string} objectId
   * @param {string} objectId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GamesApi
   */
  public gamesGameIdGuessObjectIdPost(
    gameId: string,
    objectId: string,
    gameSessionId: string,
    options?: any
  ) {
    if (options === null) {
      options = {};
    }
    options["credentials"] = "include";
    return GamesApiFp(this.configuration).gamesGameIdGuessObjectIdPost(
      gameId,
      objectId,
      gameSessionId,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @param {string} gameId
   * @param {UpdateGameRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GamesApi
   */
  public gamesGameIdPut(
    gameId: string,
    body?: UpdateGameRequest,
    options?: any
  ) {
    options = {};
    options["credentials"] = "include";
    return GamesApiFp(this.configuration).gamesGameIdPut(
      gameId,
      body,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @param {string} gameId
   * @param {boolean} setFavourite
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GamesApi
   */
  public gamesGameIdSetFavouriteSetFavouritePatch(
    gameId: string,
    setFavourite: boolean,
    options?: any
  ) {
    options = {};
    options["credentials"] = "include";
    return GamesApiFp(
      this.configuration
    ).gamesGameIdSetFavouriteSetFavouritePatch(
      gameId,
      setFavourite,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @param {string} gameId
   * @param {boolean} isPublic
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GamesApi
   */
  public gamesGameIdSetPublicIsPublicPut(
    gameId: string,
    isPublic: boolean,
    options?: any
  ) {
    options = {};
    options["credentials"] = "include";
    return GamesApiFp(this.configuration).gamesGameIdSetPublicIsPublicPut(
      gameId,
      isPublic,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @param {string} gameId
   * @param {Array<UpdateTagRequest>} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GamesApi
   */
  public gamesGameIdTagsPatch(
    gameId: string,
    body?: Array<UpdateTagRequest>,
    options?: any
  ) {
    options = {};
    options["credentials"] = "include";
    return GamesApiFp(this.configuration).gamesGameIdTagsPatch(
      gameId,
      body,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @param {string} gameId
   * @param {Array<string>} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GamesApi
   */
  public gamesGameIdTagsPut(
    gameId: string,
    body?: Array<string>,
    options?: any
  ) {
    options = {};
    options["credentials"] = "include";
    return GamesApiFp(this.configuration).gamesGameIdTagsPut(
      gameId,
      body,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @param {number} [paginationInfoPageSize]
   * @param {number} [paginationInfoPageNumber]
   * @param {number} [paginationInfoPagesCount]
   * @param {Array<string>} [filterTags]
   * @param {Array<string>} [filterKeywords]
   * @param {boolean} [filterOwn]
   * @param {boolean} [filterFavourite]
   * @param {OrderBy} [ordering]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GamesApi
   */
  public gamesGet(
    paginationInfoPageSize?: number,
    paginationInfoPageNumber?: number,
    paginationInfoPagesCount?: number,
    filterTags?: Array<string>,
    filterKeywords?: Array<string>,
    filterOwn?: boolean,
    filterFavourite?: boolean,
    ordering?: OrderBy,
    options?: any
  ) {
    options = {};
    options["credentials"] = "include";
    return GamesApiFp(this.configuration).gamesGet(
      paginationInfoPageSize,
      paginationInfoPageNumber,
      paginationInfoPagesCount,
      filterTags,
      filterKeywords,
      filterOwn,
      filterFavourite,
      ordering,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @param {number} [paginationInfoPageSize]
   * @param {number} [paginationInfoPageNumber]
   * @param {number} [paginationInfoPagesCount]
   * @param {Array<string>} [filterTags]
   * @param {Array<string>} [filterKeywords]
   * @param {boolean} [filterOwn]
   * @param {boolean} [filterFavourite]
   * @param {OrderBy} [ordering]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GamesApi
   */
  public gamesOwnGet(
    paginationInfoPageSize?: number,
    paginationInfoPageNumber?: number,
    paginationInfoPagesCount?: number,
    filterTags?: Array<string>,
    filterKeywords?: Array<string>,
    filterOwn?: boolean,
    filterFavourite?: boolean,
    ordering?: OrderBy,
    options?: any
  ) {
    options = {};
    options["credentials"] = "include";
    return GamesApiFp(this.configuration).gamesOwnGet(
      paginationInfoPageSize,
      paginationInfoPageNumber,
      paginationInfoPagesCount,
      filterTags,
      filterKeywords,
      filterOwn,
      filterFavourite,
      ordering,
      options
    )(this.fetch, this.basePath);
  }

  /**
   *
   * @param {CreateGameRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GamesApi
   */
  public gamesPost(body?: CreateGameRequest, options?: any) {
    options = {};
    options["credentials"] = "include";
    return GamesApiFp(this.configuration).gamesPost(body, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GamesApi
   */
  public gamesRecentGet(options?: any) {
    options = {};
    options["credentials"] = "include";
    return GamesApiFp(this.configuration).gamesRecentGet(options)(
      this.fetch,
      this.basePath
    );
  }
}
/**
 * TagsApi - fetch parameter creator
 * @export
 */
export const TagsApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tagsGet(options: any = {}): FetchArgs {
      const localVarPath = `/Tags`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * TagsApi - functional programming interface
 * @export
 */
export const TagsApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tagsGet(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Array<TagCount>> {
      const localVarFetchArgs =
        TagsApiFetchParamCreator(configuration).tagsGet(options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * TagsApi - factory interface
 * @export
 */
export const TagsApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    tagsGet(options?: any) {
      return TagsApiFp(configuration).tagsGet(options)(fetch, basePath);
    },
  };
};

/**
 * TagsApi - object-oriented interface
 * @export
 * @class TagsApi
 * @extends {BaseAPI}
 */
export class TagsApi extends BaseAPI {
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TagsApi
   */
  public tagsGet(options?: any) {
    options = {};
    options["credentials"] = "include";
    return TagsApiFp(this.configuration).tagsGet(options)(
      this.fetch,
      this.basePath
    );
  }
}
/**
 * UsersApi - fetch parameter creator
 * @export
 */
export const UsersApiFetchParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {LoginRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginPost(body?: LoginRequest, options: any = {}): FetchArgs {
      const localVarPath = `/login`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"LoginRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logoutGet(options: any = {}): FetchArgs {
      const localVarPath = `/logout`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {RegisterRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerPost(body?: RegisterRequest, options: any = {}): FetchArgs {
      const localVarPath = `/register`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "POST" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter["Content-Type"] = "application/json";

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );
      const needsSerialization =
        <any>"RegisterRequest" !== "string" ||
        localVarRequestOptions.headers["Content-Type"] === "application/json";
      localVarRequestOptions.body = needsSerialization
        ? JSON.stringify(body || {})
        : body || "";

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    whoamiGet(options: any = {}): FetchArgs {
      const localVarPath = `/whoami`;
      const localVarUrlObj = url.parse(localVarPath, true);
      const localVarRequestOptions = Object.assign({ method: "GET" }, options);
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = Object.assign(
        {},
        localVarUrlObj.query,
        localVarQueryParameter,
        options.query
      );
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      localVarUrlObj.search = null;
      localVarRequestOptions.headers = Object.assign(
        {},
        localVarHeaderParameter,
        options.headers
      );

      return {
        url: url.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {LoginRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginPost(
      body?: LoginRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<UserInfoResponse> {
      const localVarFetchArgs = UsersApiFetchParamCreator(
        configuration
      ).loginPost(body, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logoutGet(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs =
        UsersApiFetchParamCreator(configuration).logoutGet(options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {RegisterRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerPost(
      body?: RegisterRequest,
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
      const localVarFetchArgs = UsersApiFetchParamCreator(
        configuration
      ).registerPost(body, options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response;
          } else {
            throw response;
          }
        });
      };
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    whoamiGet(
      options?: any
    ): (fetch?: FetchAPI, basePath?: string) => Promise<UserInfoResponse> {
      const localVarFetchArgs =
        UsersApiFetchParamCreator(configuration).whoamiGet(options);
      return (
        fetch: FetchAPI = isomorphicFetch,
        basePath: string = BASE_PATH
      ) => {
        return fetch(
          basePath + localVarFetchArgs.url,
          localVarFetchArgs.options
        ).then((response) => {
          if (response.status >= 200 && response.status < 300) {
            return response.json();
          } else {
            throw response;
          }
        });
      };
    },
  };
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (
  configuration?: Configuration,
  fetch?: FetchAPI,
  basePath?: string
) {
  return {
    /**
     *
     * @param {LoginRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    loginPost(body?: LoginRequest, options?: any) {
      return UsersApiFp(configuration).loginPost(body, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    logoutGet(options?: any) {
      return UsersApiFp(configuration).logoutGet(options)(fetch, basePath);
    },
    /**
     *
     * @param {RegisterRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    registerPost(body?: RegisterRequest, options?: any) {
      return UsersApiFp(configuration).registerPost(body, options)(
        fetch,
        basePath
      );
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    whoamiGet(options?: any) {
      return UsersApiFp(configuration).whoamiGet(options)(fetch, basePath);
    },
  };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
  /**
   *
   * @param {LoginRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public loginPost(body?: LoginRequest, options?: any) {
    options = {};
    options["credentials"] = "include";
    return UsersApiFp(this.configuration).loginPost(body, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public logoutGet(options?: any) {
    options = {};
    options["credentials"] = "include";
    return UsersApiFp(this.configuration).logoutGet(options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @param {RegisterRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public registerPost(body?: RegisterRequest, options?: any) {
    options = {};
    options["credentials"] = "include";
    return UsersApiFp(this.configuration).registerPost(body, options)(
      this.fetch,
      this.basePath
    );
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof UsersApi
   */
  public whoamiGet(options?: any) {
    options = {};
    options["credentials"] = "include";
    return UsersApiFp(this.configuration).whoamiGet(options)(
      this.fetch,
      this.basePath
    );
  }
}
